/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { createAsyncAction } from 'Helpers/redux'
import { apiCall } from './api'

export const GET_ALL_GENRES = createAsyncAction('GET_ALL_GENRES')
export const getAllGenres = () =>
  apiCall({
    method: 'get',
    endpoint: '/campaign/genres',
    types: GET_ALL_GENRES,
  })

export const GET_ALL_CURATOR_GENRES = createAsyncAction(
  'GET_ALL_CURATOR_GENRES'
)
export const getAllCuratorGenres = () =>
  apiCall({
    method: 'get',
    endpoint: '/curator/genres',
    types: GET_ALL_CURATOR_GENRES,
  })

export const GET_AUTOSELECTED_PLAYLIST_GENRES = createAsyncAction(
  'GET_AUTOSELECTED_PLAYLIST_GENRES'
)

// TODO not used?
export const getAutoselectedPlaylistGenres = (id: string | number) =>
  apiCall({
    method: 'get',
    endpoint: `/curator/playlist-genres/${id}`,
    types: GET_AUTOSELECTED_PLAYLIST_GENRES,
  })

export const GET_AUTOSELECTED_SPOTIFY_PLAYLIST_GENRES = createAsyncAction(
  'GET_AUTOSELECTED_SPOTIFY_PLAYLIST_GENRES'
)
export const getAutoselectedSpotifyPlaylistGenres = (
  id: number | string,
  callback: (
    error: string,
    payload: { autoselectedGenres: Array<{ id: number; genreName: string }> }
  ) => void
) =>
  apiCall({
    method: 'get',
    endpoint: `/curator/playlist-genres?spotifyPlaylistId=${id}`,
    types: GET_AUTOSELECTED_SPOTIFY_PLAYLIST_GENRES,
    callback,
  })

export const GET_PLAYLISTS_FOR_GENRE = createAsyncAction(
  'GET_PLAYLISTS_FOR_GENRE'
)

// TODO not used
export const getPlaylistsForGenre = (genreName: string, callback: () => void) =>
  apiCall({
    method: 'get',
    endpoint: `/campaign/playlists-genres/${genreName}`,
    types: GET_PLAYLISTS_FOR_GENRE,
    callback,
  })
